import * as React from "react";
const HighlightsIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={16} height={14} viewBox="0 0 16 14" {...props}>
    <path
      fill="currentColor"
      d="M0 9c0-.552.597-1 1.333-1h13.334C15.403 8 16 8.448 16 9v4c0 .552-.597 1-1.333 1H1.333C.597 14 0 13.552 0 13zm0-8c0-.552.597-1 1.333-1h13.334C15.403 0 16 .448 16 1v4c0 .552-.597 1-1.333 1H1.333C.597 6 0 5.552 0 5zm14 11v-2H2v2zm0-8V2H2v2z"
    />
  </svg>
);
export default HighlightsIcon;
